<template>
  <div class="container subscribe_to_newsletter">
    <component
      class="default-title text-center"
      :is="title_tag">
      {{ get_title }}
    </component>
    <div class="subscribe_to_newsletter-block">
      <form class="subscribe-form" @submit.prevent="sendSubscription()">
        <div class="subscribe-form_top">
          <default-input
            class="subscribe-form_name"
            :placeholder="$t('input_placeholder.name')"
            required
            name="name"
            v-model="subscribe.name"
            maxlength="150"
          />
          <default-input
            class="subscribe-form_email"
            :placeholder="$t('input_placeholder.e_mail_short')"
            required
            name="email"
            type="email"
            v-model="subscribe.email"
            maxlength="150"
          />
          <default-button
            v-if="!getIsMobile"
            type="submit"
            class="subscribe-form_button"
            :disabled="loading">
            {{ $t('btn.subscribe') }}
          </default-button>
        </div>
        <div class="subscribe-form_bottom">
          <label class="terms-checkbox">
            <input required type="checkbox"
                   :value="agreeded"
                   v-model="agreeded"
                   @input="$emit('input', $event.target.checked)">
            <span v-html="`${$t('text.terms')}*`"/>
          </label>
          <default-button
            v-if="getIsMobile"
            :disabled="loading"
            type="submit"
            class="subscribe-form_button">{{ $t('btn.subscribe') }}
          </default-button>
        </div>
      </form>
    </div>
    <form-submitting-popup
      ref="form_submitting_modal"
      :info_icon="resp_error"
      :title="resp_error ? $t('text.subscribe_title_error') : $t('text.subscribe_title')"
      :body="resp_error ? '' : $t('text.subscribe_body')"
    />
  </div>
</template>

<script>
import HtmlBlock from "../small_parts/HtmlBlock";
import DefaultTitle from "../small_parts/DefaultTitle.vue";
import {axiosSubscribe} from "../../../admin/helpers/axios_requests";
import DefaultButton from "../slots/DefaultButton.vue";
import {NEW_SUBSCRIBER} from "../../helpers/new_objects";
import FormSubmittingPopup from "../modals/FormSubmittingPopup.vue";
import TermsCheckbox from "../small_parts/TermsCheckbox.vue";
import {mapGetters} from "vuex";
import DefaultInput from "../small_parts/DefaultInput.vue";

export default {
  name: "SubscribeToNewsletterBlock",
  components: {
    DefaultInput,
    TermsCheckbox,
    FormSubmittingPopup,
    DefaultButton,
    DefaultTitle,
    HtmlBlock
  },
  props: {
    /**props**/
    content: {
      type: String,
      default: 'Subscribe to Veo\'s Newslwtter',
      admin_type: 'editor',
    },
    title: {
      type: String,
      default: '',
      admin_type: 'input',
    },
    title_tag: {
      type: String,
      default: 'h3',
      admin_type: 'select',
      admin_data_values: [
        'h1', 'h2', 'h3', 'h4', 'h5', 'h6'
      ],
    },
    /**props**/
  },
  computed: {
    ...mapGetters([
      'getIsMobile'
    ]),
    get_title() {
      if (this.title) {
        return this.title
      }
      return this.$t('text.subscribe_form_title')
    },
  },
  data() {
    return {
      subscribe: [],
      loading: false,
      resp_error: false,
      agreeded: false,
    }
  },
  created() {
    this.$set(this, 'subscribe', NEW_SUBSCRIBER())
  },
  methods: {
    sendSubscription() {
      if (!this.agreeded) {
        alert(this.$t('text.agree_confirm'));
        return;
      }
      this.loading = true
      this.resp_error = false
      axiosSubscribe.send(this.subscribe)
        .then(r => {
          this.showSubmittedModal()
          this.agreeded = false;
          this.subscribe = NEW_SUBSCRIBER()
        })
        .catch(({response}) => {
          console.log(response.status);
          let mail_error = (response?.data?.errors?.email || []).shift()
          if (mail_error !== 'The email has already been taken.') return
          this.resp_error = true
          this.showSubmittedModal()
          }
        )
        .finally(() => {
          this.loading = false
        })
    },
    showSubmittedModal() {
      this.$refs.form_submitting_modal.openModal(true);
    },
  }
}
</script>
